"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entitySlideoutDetailsId = void 0;
exports.entitySlideoutDetailsId = 'classifier-entity-slideout-details';
